/**
 * Replace any non-alpha characters except for underscores with underscores
 */
export function sanitiseRecaptchaAction(action: string): string {
  return action.replace(/[^A-Za-z/_]/g, '_');
}
